import React from 'react';
import EmailVerification from '../components/auth/EmailVerification';

const EmailVerificationPage = () => {
  return <EmailVerification />;
};

export default EmailVerificationPage;
